import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "stickers" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StickerComponent = _resolveComponent("StickerComponent")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stickers, (sticker) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        class: "sticker",
        key: sticker.name,
        to: { name:
      'sticker', params: { name: sticker.name } }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_StickerComponent, { sticker: sticker }, null, 8, ["sticker"])
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}